module.exports = __webpack_public_path__ + "static/media/Big_blue_sapphire.c5f7b491.png";